function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { deepClone, generateId, getDefaultFormConfig, overwriteObj } from '@/utils/util';
import { containers, advancedFields, basicFields, customFields } from '@/components/form-designer/widget-panel/widgetsConfig.js';
import { del } from 'vue';
export function createDesigner(vueInstance) {
  var defaultFormConfig = deepClone(getDefaultFormConfig());
  return _defineProperty(_defineProperty(_defineProperty({
    widgetList: [],
    formConfig: {
      cssCode: ''
    },
    selectedId: null,
    selectedWidget: null,
    selectedWidgetName: null,
    //选中组件名称（唯一）
    vueInstance: vueInstance,
    selectNames: [],
    //已添加组件名称数组
    formWidget: null,
    //表单设计容器

    cssClassList: [],
    //自定义样式列表
    containersNames: containers.map(function (con) {
      return con.type;
    }),
    chartContainers: [],
    historyData: {
      index: -1,
      //index: 0,
      maxStep: 20,
      steps: []
    },
    initDesigner: function initDesigner(resetFormJson) {
      this.widgetList = [];
      this.formConfig = deepClone(defaultFormConfig);
      if (!resetFormJson) {
        this.initHistoryData();
      }
    },
    clearDesigner: function clearDesigner(skipHistoryChange) {
      var emptyWidgetListFlag = this.widgetList.length === 0;
      this.widgetList = [];
      this.selectedId = null;
      this.selectNames = [];
      this.selectedWidgetName = null;
      this.selectedWidget = {}; //this.selectedWidget = null
      overwriteObj(this.formConfig, defaultFormConfig); //

      if (!!skipHistoryChange) {
        //什么也不做！！
      } else if (!emptyWidgetListFlag) {
        this.emitHistoryChange();
      } else {
        this.saveCurrentHistoryStep();
      }
    },
    loadPresetCssCode: function loadPresetCssCode(preCssCode) {
      if (this.formConfig.cssCode === '' && !!preCssCode) {
        this.formConfig.cssCode = preCssCode;
      }
    },
    getLayoutType: function getLayoutType() {
      return this.formConfig.layoutType || 'PC';
    },
    changeLayoutType: function changeLayoutType(newType) {
      this.formConfig.layoutType = newType;
    },
    getImportTemplate: function getImportTemplate() {
      return {
        widgetList: [],
        // formConfig: deepClone(this.formConfig)
        formConfig: deepClone(defaultFormConfig)
      };
    },
    loadFormJson: function loadFormJson(formJson) {
      var modifiedFlag = false;
      if (!!formJson && !!formJson.widgetList) {
        this.formWidget.clearWidgetRefList();
        this.widgetList = formJson.widgetList;
        modifiedFlag = true;
      }
      if (!!formJson && !!formJson.formConfig) {
        //this.formConfig = importObj.formConfig
        overwriteObj(this.formConfig, formJson.formConfig); /* 用=赋值，会导致inject依赖注入的formConfig属性变成非响应式 */
        modifiedFlag = true;
      }
      if (modifiedFlag) {
        this.emitEvent('form-json-imported', []); // 通知其他组件
      }
      return modifiedFlag;
    },
    setNamesList: function setNamesList(selected) {
      if (!selected) {
        return;
      }
      if (!!selected.id && !this.containersNames.includes(selected.type)) {
        this.selectNames.push(selected.options.name);
      }
    },
    setSelected: function setSelected(selected) {
      if (!selected) {
        this.clearSelected();
        return;
      }
      this.selectedWidget = selected;
      if (!!selected.id) {
        this.selectedId = selected.id;
        this.selectedWidgetName = selected.options.name;
      }
    },
    updateSelectedWidgetNameAndLabel: function updateSelectedWidgetNameAndLabel(selectedWidget, newName, newLabel) {
      this.selectedWidgetName = newName;
      //selectedWidget.options.name = newName  //此行多余
      if (!!newLabel && Object.keys(selectedWidget.options).indexOf('label') > -1) {
        selectedWidget.options.label = newLabel;
      }
    },
    clearSelected: function clearSelected() {
      this.selectedId = null;
      this.selectedWidgetName = null;
      this.selectedWidget = {}; //this.selectedWidget = null
    },
    checkWidgetMove: function checkWidgetMove(evt) {
      /* Only field widget can be dragged into sub-form */
      if (!!evt.draggedContext && !!evt.draggedContext.element) {
        var wgCategory = evt.draggedContext.element.category;
        var wgType = evt.draggedContext.element.type;
        if (!!evt.to) {
          if (evt.to.className === 'sub-form-table' && wgCategory === 'container') {
            //this.$message.info(this.vueInstance.i18nt('designer.hint.onlyFieldWidgetAcceptable'))
            return false;
          }
        }
      }
      return true;
    },
    checkFieldMove: function checkFieldMove(evt) {
      if (!!evt.draggedContext && !!evt.draggedContext.element) {
        var wgCategory = evt.draggedContext.element.category;
        var wgType = evt.draggedContext.element.type + '';
        if (!!evt.to) {
          if (evt.to.className === 'sub-form-table' && wgType === 'slot') {
            //this.$message.info(this.vueInstance.i18nt('designer.hint.onlyFieldWidgetAcceptable'))
            return false;
          }
        }
      }
      return true;
    },
    /**
     * 追加表格新行
     * @param widget
     */
    appendTableRow: function appendTableRow(widget) {
      var rowIdx = widget.rows.length; //确定插入行位置
      var newRow = deepClone(widget.rows[widget.rows.length - 1]);
      newRow.id = 'table-row-' + generateId();
      newRow.merged = false;
      newRow.cols.forEach(function (col) {
        col.id = 'table-cell-' + generateId();
        // col.options.name = col.id
        col.merged = false;
        col.options.colspan = 1;
        col.options.rowspan = 1;
        col.widgetList.length = 0;
      });
      widget.rows.splice(rowIdx, 0, newRow);
      this.emitHistoryChange();
    },
    /**
     * 追加表格新列
     * @param widget
     */
    appendTableCol: function appendTableCol(widget) {
      var _this = this;
      var colIdx = widget.rows[0].cols.length; //确定插入列位置
      widget.rows.forEach(function (row) {
        var newCol = deepClone(_this.getContainerByType('table-cell'));
        newCol.id = 'table-cell-' + generateId();
        // newCol.options.name = newCol.id
        newCol.merged = false;
        newCol.options.colspan = 1;
        newCol.options.rowspan = 1;
        newCol.widgetList.length = 0;
        row.cols.splice(colIdx, 0, newCol);
      });
      this.emitHistoryChange();
    },
    insertTableRow: function insertTableRow(widget, insertPos, cloneRowIdx, curCol, aboveFlag) {
      var newRowIdx = !!aboveFlag ? insertPos : insertPos + 1; //初步确定插入行位置
      if (!aboveFlag) {
        //继续向下寻找同列第一个未被合并的单元格
        var tmpRowIdx = newRowIdx;
        var rowFoundFlag = false;
        while (tmpRowIdx < widget.rows.length) {
          if (!widget.rows[tmpRowIdx].cols[curCol].merged) {
            newRowIdx = tmpRowIdx;
            rowFoundFlag = true;
            break;
          } else {
            tmpRowIdx++;
          }
        }
        if (!rowFoundFlag) {
          newRowIdx = widget.rows.length;
        }
      }
      var newRow = deepClone(widget.rows[cloneRowIdx]);
      newRow.id = 'table-row-' + generateId();
      newRow.merged = false;
      newRow.cols.forEach(function (col) {
        col.id = 'table-cell-' + generateId();
        // col.options.name = col.id
        col.merged = false;
        col.options.colspan = 1;
        col.options.rowspan = 1;
        col.widgetList.length = 0;
      });
      widget.rows.splice(newRowIdx, 0, newRow);
      var colNo = 0;
      while (newRowIdx < widget.rows.length - 1 && colNo < widget.rows[0].cols.length) {
        //越界判断
        var cellOfNextRow = widget.rows[newRowIdx + 1].cols[colNo];
        var rowMerged = cellOfNextRow.merged; //确定插入位置下一行的单元格是否为合并单元格
        if (!!rowMerged) {
          var rowArray = widget.rows;
          var unMergedCell = {};
          var startRowIndex = null;
          for (var i = newRowIdx; i >= 0; i--) {
            //查找该行已合并的主单元格
            if (!rowArray[i].cols[colNo].merged && rowArray[i].cols[colNo].options.rowspan > 1) {
              startRowIndex = i;
              unMergedCell = rowArray[i].cols[colNo];
              break;
            }
          }
          if (!!unMergedCell.options) {
            //如果有符合条件的unMergedCell
            var newRowspan = unMergedCell.options.rowspan + 1;
            this.setPropsOfMergedRows(widget.rows, startRowIndex, colNo, unMergedCell.options.colspan, newRowspan);
            colNo += unMergedCell.options.colspan;
          } else {
            colNo += 1;
          }
        } else {
          //colNo += 1
          colNo += cellOfNextRow.options.colspan || 1;
        }
      }
      this.emitHistoryChange();
    },
    insertTableCol: function insertTableCol(widget, insertPos, curRow, leftFlag) {
      var _this2 = this;
      var newColIdx = !!leftFlag ? insertPos : insertPos + 1; //初步确定插入列位置
      if (!leftFlag) {
        //继续向右寻找同行第一个未被合并的单元格
        var tmpColIdx = newColIdx;
        var colFoundFlag = false;
        while (tmpColIdx < widget.rows[curRow].cols.length) {
          if (!widget.rows[curRow].cols[tmpColIdx].merged) {
            newColIdx = tmpColIdx;
            colFoundFlag = true;
            break;
          } else {
            tmpColIdx++;
          }
          if (!colFoundFlag) {
            newColIdx = widget.rows[curRow].cols.length;
          }
        }
      }
      widget.rows.forEach(function (row) {
        var newCol = deepClone(_this2.getContainerByType('table-cell'));
        newCol.id = 'table-cell-' + generateId();
        // newCol.options.name = newCol.id
        newCol.merged = false;
        newCol.options.colspan = 1;
        newCol.options.rowspan = 1;
        newCol.widgetList.length = 0;
        row.cols.splice(newColIdx, 0, newCol);
      });
      var rowNo = 0;
      while (newColIdx < widget.rows[0].cols.length - 1 && rowNo < widget.rows.length) {
        //越界判断
        var cellOfNextCol = widget.rows[rowNo].cols[newColIdx + 1];
        var colMerged = cellOfNextCol.merged; //确定插入位置右侧列的单元格是否为合并单元格
        if (!!colMerged) {
          var colArray = widget.rows[rowNo].cols;
          var unMergedCell = {};
          var startColIndex = null;
          for (var i = newColIdx; i >= 0; i--) {
            //查找该行已合并的主单元格
            if (!colArray[i].merged && colArray[i].options.colspan > 1) {
              startColIndex = i;
              unMergedCell = colArray[i];
              break;
            }
          }
          if (!!unMergedCell.options) {
            //如果有符合条件的unMergedCell
            var newColspan = unMergedCell.options.colspan + 1;
            this.setPropsOfMergedCols(widget.rows, rowNo, startColIndex, newColspan, unMergedCell.options.rowspan);
            rowNo += unMergedCell.options.rowspan;
          } else {
            rowNo += 1;
          }
        } else {
          //rowNo += 1
          rowNo += cellOfNextCol.options.rowspan || 1;
        }
      }
      this.emitHistoryChange();
    },
    setPropsOfMergedCols: function setPropsOfMergedCols(rowArray, startRowIndex, startColIndex, newColspan, rowspan) {
      for (var i = startRowIndex; i < startRowIndex + rowspan; i++) {
        for (var j = startColIndex; j < startColIndex + newColspan; j++) {
          if (i === startRowIndex && j === startColIndex) {
            rowArray[i].cols[j].options.colspan = newColspan; //合并后的主单元格
            continue;
          }
          rowArray[i].cols[j].merged = true;
          rowArray[i].cols[j].options.colspan = newColspan;
          rowArray[i].cols[j].widgetList = [];
        }
      }
    },
    setPropsOfMergedRows: function setPropsOfMergedRows(rowArray, startRowIndex, startColIndex, colspan, newRowspan) {
      for (var i = startRowIndex; i < startRowIndex + newRowspan; i++) {
        for (var j = startColIndex; j < startColIndex + colspan; j++) {
          if (i === startRowIndex && j === startColIndex) {
            rowArray[i].cols[j].options.rowspan = newRowspan;
            continue;
          }
          rowArray[i].cols[j].merged = true;
          rowArray[i].cols[j].options.rowspan = newRowspan;
          rowArray[i].cols[j].widgetList = [];
        }
      }
    },
    setPropsOfSplitCol: function setPropsOfSplitCol(rowArray, startRowIndex, startColIndex, colspan, rowspan) {
      for (var i = startRowIndex; i < startRowIndex + rowspan; i++) {
        for (var j = startColIndex; j < startColIndex + colspan; j++) {
          rowArray[i].cols[j].merged = false;
          rowArray[i].cols[j].options.rowspan = 1;
          rowArray[i].cols[j].options.colspan = 1;
        }
      }
    },
    setPropsOfSplitRow: function setPropsOfSplitRow(rowArray, startRowIndex, startColIndex, colspan, rowspan) {
      for (var i = startRowIndex; i < startRowIndex + rowspan; i++) {
        for (var j = startColIndex; j < startColIndex + colspan; j++) {
          rowArray[i].cols[j].merged = false;
          rowArray[i].cols[j].options.rowspan = 1;
          rowArray[i].cols[j].options.colspan = 1;
        }
      }
    },
    mergeTableCol: function mergeTableCol(rowArray, colArray, curRow, curCol, leftFlag, cellWidget) {
      var mergedColIdx = !!leftFlag ? curCol : curCol + colArray[curCol].options.colspan;

      // let remainedColIdx = !!leftFlag ? curCol - colArray[curCol - 1].options.colspan : curCol
      var remainedColIdx = !!leftFlag ? curCol - 1 : curCol;
      if (!!leftFlag) {
        //继续向左寻找同行未被合并的第一个单元格
        var tmpColIdx = remainedColIdx;
        while (tmpColIdx >= 0) {
          if (!rowArray[curRow].cols[tmpColIdx].merged) {
            remainedColIdx = tmpColIdx;
            break;
          } else {
            tmpColIdx--;
          }
        }
      }
      if (!!colArray[mergedColIdx].widgetList && colArray[mergedColIdx].widgetList.length > 0) {
        //保留widgetList
        if (!colArray[remainedColIdx].widgetList || colArray[remainedColIdx].widgetList.length === 0) {
          colArray[remainedColIdx].widgetList = deepClone(colArray[mergedColIdx].widgetList);
        }
      }
      var newColspan = colArray[mergedColIdx].options.colspan * 1 + colArray[remainedColIdx].options.colspan * 1;
      this.setPropsOfMergedCols(rowArray, curRow, remainedColIdx, newColspan, cellWidget.options.rowspan);
      this.emitHistoryChange();
    },
    mergeTableWholeRow: function mergeTableWholeRow(rowArray, colArray, rowIndex, colIndex) {
      //需要考虑操作的行存在已合并的单元格！！
      //整行所有单元格行高不一致不可合并！！
      var startRowspan = rowArray[rowIndex].cols[0].options.rowspan;
      var unmatchedFlag = false;
      for (var i = 1; i < rowArray[rowIndex].cols.length; i++) {
        if (rowArray[rowIndex].cols[i].options.rowspan !== startRowspan) {
          unmatchedFlag = true;
          break;
        }
      }
      if (unmatchedFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.rowspanNotConsistentForMergeEntireRow'));
        return;
      }
      var widgetListCols = colArray.filter(function (colItem) {
        return !colItem.merged && !!colItem.widgetList && colItem.widgetList.length > 0;
      });
      if (!!widgetListCols && widgetListCols.length > 0) {
        //保留widgetList
        if (widgetListCols[0].id !== colArray[0].id && (!colArray[0].widgetList || colArray[0].widgetList.length <= 0)) {
          colArray[0].widgetList = deepClone(widgetListCols[0].widgetList);
        }
      }
      this.setPropsOfMergedCols(rowArray, rowIndex, 0, colArray.length, colArray[colIndex].options.rowspan);
      this.emitHistoryChange();
    },
    mergeTableRow: function mergeTableRow(rowArray, curRow, curCol, aboveFlag, cellWidget) {
      var mergedRowIdx = !!aboveFlag ? curRow : curRow + cellWidget.options.rowspan;

      //let remainedRowIdx = !!aboveFlag ? curRow - cellWidget.options.rowspan : curRow
      var remainedRowIdx = !!aboveFlag ? curRow - 1 : curRow;
      if (!!aboveFlag) {
        //继续向上寻找同列未被合并的第一个单元格
        var tmpRowIdx = remainedRowIdx;
        while (tmpRowIdx >= 0) {
          if (!rowArray[tmpRowIdx].cols[curCol].merged) {
            remainedRowIdx = tmpRowIdx;
            break;
          } else {
            tmpRowIdx--;
          }
        }
      }
      if (!!rowArray[mergedRowIdx].cols[curCol].widgetList && rowArray[mergedRowIdx].cols[curCol].widgetList.length > 0) {
        //保留widgetList
        if (!rowArray[remainedRowIdx].cols[curCol].widgetList || rowArray[remainedRowIdx].cols[curCol].widgetList.length === 0) {
          rowArray[remainedRowIdx].cols[curCol].widgetList = deepClone(rowArray[mergedRowIdx].cols[curCol].widgetList);
        }
      }
      var newRowspan = rowArray[mergedRowIdx].cols[curCol].options.rowspan * 1 + rowArray[remainedRowIdx].cols[curCol].options.rowspan * 1;
      this.setPropsOfMergedRows(rowArray, remainedRowIdx, curCol, cellWidget.options.colspan, newRowspan);
      this.emitHistoryChange();
    },
    mergeTableWholeCol: function mergeTableWholeCol(rowArray, colArray, rowIndex, colIndex) {
      //需要考虑操作的列存在已合并的单元格！！
      //整列所有单元格列宽不一致不可合并！！
      var startColspan = rowArray[0].cols[colIndex].options.colspan;
      var unmatchedFlag = false;
      for (var i = 1; i < rowArray.length; i++) {
        if (rowArray[i].cols[colIndex].options.colspan !== startColspan) {
          unmatchedFlag = true;
          break;
        }
      }
      if (unmatchedFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.colspanNotConsistentForMergeEntireColumn'));
        return;
      }
      var widgetListCols = [];
      rowArray.forEach(function (rowItem) {
        var tempCell = rowItem.cols[colIndex];
        if (!tempCell.merged && !!tempCell.widgetList && tempCell.widgetList.length > 0) {
          widgetListCols.push(tempCell);
        }
      });
      var firstCellOfCol = rowArray[0].cols[colIndex];
      if (!!widgetListCols && widgetListCols.length > 0) {
        //保留widgetList
        if (widgetListCols[0].id !== firstCellOfCol.id && (!firstCellOfCol.widgetList || firstCellOfCol.widgetList.length <= 0)) {
          firstCellOfCol.widgetList = deepClone(widgetListCols[0].widgetList);
        }
      }
      this.setPropsOfMergedRows(rowArray, 0, colIndex, firstCellOfCol.options.colspan, rowArray.length);
      this.emitHistoryChange();
    },
    undoMergeTableCol: function undoMergeTableCol(rowArray, rowIndex, colIndex, colspan, rowspan) {
      this.setPropsOfSplitCol(rowArray, rowIndex, colIndex, colspan, rowspan);
      this.emitHistoryChange();
    },
    undoMergeTableRow: function undoMergeTableRow(rowArray, rowIndex, colIndex, colspan, rowspan) {
      this.setPropsOfSplitRow(rowArray, rowIndex, colIndex, colspan, rowspan);
      this.emitHistoryChange();
    },
    deleteTableWholeCol: function deleteTableWholeCol(rowArray, colIndex) {
      //需考虑删除的是合并列！！
      var onlyOneColFlag = true;
      rowArray.forEach(function (ri) {
        if (ri.cols[0].options.colspan !== rowArray[0].cols.length) {
          onlyOneColFlag = false;
        }
      });
      //仅剩一列则不可删除！！
      if (onlyOneColFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.lastColCannotBeDeleted'));
        return;
      }

      //整列所有单元格列宽不一致不可删除！！
      var startColspan = rowArray[0].cols[colIndex].options.colspan;
      var unmatchedFlag = false;
      for (var i = 1; i < rowArray.length; i++) {
        if (rowArray[i].cols[colIndex].options.colspan !== startColspan) {
          unmatchedFlag = true;
          break;
        }
      }
      if (unmatchedFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.colspanNotConsistentForDeleteEntireColumn'));
        return;
      }
      rowArray.forEach(function (rItem) {
        rItem.cols.splice(colIndex, startColspan);
      });
      this.emitHistoryChange();
    },
    deleteTableWholeRow: function deleteTableWholeRow(rowArray, rowIndex) {
      //需考虑删除的是合并行！！
      var onlyOneRowFlag = true;
      rowArray[0].cols.forEach(function (ci) {
        if (ci.options.rowspan !== rowArray.length) {
          onlyOneRowFlag = false;
        }
      });
      //仅剩一行则不可删除！！
      if (onlyOneRowFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.lastRowCannotBeDeleted'));
        return;
      }

      //整行所有单元格行高不一致不可删除！！
      var startRowspan = rowArray[rowIndex].cols[0].options.rowspan;
      var unmatchedFlag = false;
      for (var i = 1; i < rowArray[rowIndex].cols.length; i++) {
        if (rowArray[rowIndex].cols[i].options.rowspan !== startRowspan) {
          unmatchedFlag = true;
          break;
        }
      }
      if (unmatchedFlag) {
        this.vueInstance.$message.info(this.vueInstance.i18nt('designer.hint.rowspanNotConsistentForDeleteEntireRow'));
        return;
      }
      rowArray.splice(rowIndex, startRowspan);
      this.emitHistoryChange();
    },
    getContainerByType: function getContainerByType(typeName) {
      var allWidgets = [].concat(_toConsumableArray(containers), _toConsumableArray(basicFields), _toConsumableArray(advancedFields), _toConsumableArray(customFields));
      var foundCon = null;
      allWidgets.forEach(function (con) {
        if (!!con.category && !!con.type && con.type === typeName) {
          foundCon = con;
        }
      });
      return foundCon;
    },
    getFieldWidgetByType: function getFieldWidgetByType(typeName) {
      var allWidgets = [].concat(_toConsumableArray(containers), _toConsumableArray(basicFields), _toConsumableArray(advancedFields), _toConsumableArray(customFields));
      var foundWidget = null;
      allWidgets.forEach(function (widget) {
        if (!!!widget.category && !!widget.type && widget.type === typeName) {
          foundWidget = widget;
        }
      });
      return foundWidget;
    },
    hasConfig: function hasConfig(widget, configName) {
      var originalWidget = null;
      if (!!widget.category) {
        originalWidget = this.getContainerByType(widget.type);
      } else {
        originalWidget = this.getFieldWidgetByType(widget.type);
      }
      if (!originalWidget || !originalWidget.options) {
        return false;
      }
      return Object.keys(originalWidget.options).indexOf(configName) > -1;
    },
    upgradeWidgetConfig: function upgradeWidgetConfig(oldWidget) {
      var newWidget = null;
      if (!!oldWidget.category) {
        newWidget = this.getContainerByType(oldWidget.type);
      } else {
        newWidget = this.getFieldWidgetByType(oldWidget.type);
      }
      if (!newWidget || !newWidget.options) {
        return;
      }
      Object.keys(newWidget.options).forEach(function (ck) {
        if (!oldWidget.hasOwnProperty(ck)) {
          oldWidget.options[ck] = deepClone(newWidget.options[ck]);
        }
      });
    },
    upgradeFormConfig: function upgradeFormConfig(oldFormConfig) {
      var _this3 = this;
      Object.keys(this.formConfig).forEach(function (fc) {
        if (!oldFormConfig.hasOwnProperty(fc)) {
          oldFormConfig[fc] = deepClone(_this3.formConfig[fc]);
        }
      });
    },
    cloneGridCol: function cloneGridCol(widget, parentWidget) {
      var newGridCol = deepClone(this.getContainerByType('grid-col'));
      newGridCol.options.span = widget.options.span;
      var tmpId = generateId();
      newGridCol.id = 'grid-col-' + tmpId;
      newGridCol.options.name = 'gridCol' + tmpId;
      parentWidget.cols.push(newGridCol);
    },
    cloneContainer: function cloneContainer(containWidget) {
      var _this4 = this;
      if (containWidget.type === 'grid') {
        var newGrid = deepClone(this.getContainerByType('grid'));
        newGrid.id = newGrid.type + generateId();
        newGrid.options.name = newGrid.id;
        containWidget.cols.forEach(function (gridCol) {
          var newGridCol = deepClone(_this4.getContainerByType('grid-col'));
          var tmpId = generateId();
          newGridCol.id = 'grid-col-' + tmpId;
          newGridCol.options.name = 'gridCol' + tmpId;
          newGridCol.options.span = gridCol.options.span;
          newGrid.cols.push(newGridCol);
        });
        return newGrid;
      } else if (containWidget.type === 'table') {
        var newTable = deepClone(this.getContainerByType('table'));
        newTable.id = newTable.type + generateId();
        newTable.options.name = newTable.id;
        containWidget.rows.forEach(function (tRow) {
          var newRow = deepClone(tRow);
          newRow.id = 'table-row-' + generateId();
          newRow.cols.forEach(function (col) {
            col.id = 'table-cell-' + generateId();
            col.options.name = col.id;
            col.widgetList = []; //清空组件列表
          });
          newTable.rows.push(newRow);
        });
        return newTable;
      } else {
        //其他容器组件不支持clone操作
        return null;
      }
    },
    moveUpWidget: function moveUpWidget(parentList, indexOfParentList) {
      if (!!parentList) {
        if (indexOfParentList === 0) {
          this.vueInstance.$message(this.vueInstance.i18nt('designer.hint.moveUpFirstChildHint'));
          return;
        }
        var tempWidget = parentList[indexOfParentList];
        parentList.splice(indexOfParentList, 1);
        parentList.splice(indexOfParentList - 1, 0, tempWidget);
      }
    },
    moveDownWidget: function moveDownWidget(parentList, indexOfParentList) {
      if (!!parentList) {
        if (indexOfParentList === parentList.length - 1) {
          this.vueInstance.$message(this.vueInstance.i18nt('designer.hint.moveDownLastChildHint'));
          return;
        }
        var tempWidget = parentList[indexOfParentList];
        parentList.splice(indexOfParentList, 1);
        parentList.splice(indexOfParentList + 1, 0, tempWidget);
      }
    },
    copyNewFieldWidget: function copyNewFieldWidget(origin) {
      var newWidget = deepClone(origin);
      var tempId = generateId();
      newWidget.id = newWidget.type.replace(/-/g, '') + tempId;
      // newWidget.options.name = newWidget.id
      // newWidget.options.label = newWidget.options.label || newWidget.type.toLowerCase()

      delete newWidget.displayName;
      return newWidget;
    },
    copyNewContainerWidget: function copyNewContainerWidget(origin) {
      var newCon = deepClone(origin);
      newCon.id = newCon.type.replace(/-/g, '') + generateId();
      newCon.options.name = newCon.id;
      if (newCon.type === 'grid') {
        var newCol = deepClone(this.getContainerByType('grid-col'));
        var tmpId = generateId();
        newCol.id = 'grid-col-' + tmpId;
        newCol.options.name = 'gridCol' + tmpId;
        newCon.cols.push(newCol);
        //
        newCol = deepClone(newCol);
        tmpId = generateId();
        newCol.id = 'grid-col-' + tmpId;
        newCol.options.name = 'gridCol' + tmpId;
        newCon.cols.push(newCol);
      } else if (newCon.type === 'table') {
        var newRow = {
          cols: []
        };
        newRow.id = 'table-row-' + generateId();
        newRow.merged = false;
        var newCell = deepClone(this.getContainerByType('table-cell'));
        newCell.id = 'table-cell-' + generateId();
        // newCell.options.name = newCell.id
        newCell.merged = false;
        newCell.options.colspan = 1;
        newCell.options.rowspan = 1;
        newRow.cols.push(newCell);
        newCon.rows.push(newRow);
      } else if (newCon.type === 'tab') {
        var newTabPane = deepClone(this.getContainerByType('tab-pane'));
        newTabPane.id = 'tab-pane-' + generateId();
        newTabPane.options.name = 'tab1';
        newTabPane.options.label = 'tab 1';
        newCon.tabs.push(newTabPane);
      }
      //newCon.options.customClass = []

      delete newCon.displayName;
      return newCon;
    },
    addContainerByDbClick: function addContainerByDbClick(container) {
      var newCon = this.copyNewContainerWidget(container);
      this.widgetList.push(newCon);
      this.setSelected(newCon);
    },
    addFieldByDbClick: function addFieldByDbClick(widget) {
      var newWidget = this.copyNewFieldWidget(widget);
      if (!!this.selectedWidget && this.selectedWidget.type === 'tab') {
        //获取当前激活的tabPane
        var activeTab = this.selectedWidget.tabs[0];
        this.selectedWidget.tabs.forEach(function (tabPane) {
          if (!!tabPane.options.active) {
            activeTab = tabPane;
          }
        });
        !!activeTab && activeTab.widgetList.push(newWidget);
      } else if (!!this.selectedWidget && !!this.selectedWidget.widgetList) {
        this.selectedWidget.widgetList.push(newWidget);
      } else {
        this.widgetList.push(newWidget);
      }
      this.setSelected(newWidget);
      this.emitHistoryChange();
      this.setNamesList(newWidget);
    },
    deleteColOfGrid: function deleteColOfGrid(gridWidget, colIdx) {
      if (!!gridWidget && !!gridWidget.cols) {
        gridWidget.cols.splice(colIdx, 1);
      }
    },
    addNewColOfGrid: function addNewColOfGrid(gridWidget) {
      var cols = gridWidget.cols;
      var newGridCol = deepClone(this.getContainerByType('grid-col'));
      var tmpId = generateId();
      newGridCol.id = 'grid-col-' + tmpId;
      newGridCol.options.name = 'gridCol' + tmpId;
      if (!!cols && cols.length > 0) {
        var spanSum = 0;
        cols.forEach(function (col) {
          spanSum += col.options.span;
        });
        if (spanSum >= 24) {
          gridWidget.cols.push(newGridCol);
        } else {
          newGridCol.options.span = 24 - spanSum > 12 ? 12 : 24 - spanSum;
          gridWidget.cols.push(newGridCol);
        }
      } else {
        gridWidget.cols = [newGridCol];
      }
    },
    addTabPaneOfTabs: function addTabPaneOfTabs(tabsWidget) {
      var tabPanes = tabsWidget.tabs;
      var newTabPane = deepClone(this.getContainerByType('tab-pane'));
      newTabPane.id = 'tab-pane-' + generateId();
      newTabPane.options.name = newTabPane.id;
      newTabPane.options.label = 'tab ' + (tabPanes.length + 1);
      tabPanes.push(newTabPane);
    },
    deleteTabPaneOfTabs: function deleteTabPaneOfTabs(tabsWidget, tpIdx) {
      tabsWidget.tabs.splice(tpIdx, 1);
    },
    emitEvent: function emitEvent(evtName, evtData) {
      //用于兄弟组件发射事件
      this.vueInstance.$emit(evtName, evtData);
    },
    handleEvent: function handleEvent(evtName, callback) {
      //用于兄弟组件接收事件
      this.vueInstance.$on(evtName, function (data) {
        return callback(data);
      });
    },
    setCssClassList: function setCssClassList(cssClassList) {
      this.cssClassList = cssClassList;
    },
    getCssClassList: function getCssClassList() {
      return this.cssClassList;
    },
    registerFormWidget: function registerFormWidget(formWidget) {
      this.formWidget = formWidget;
    },
    initHistoryData: function initHistoryData() {
      this.loadFormContentFromStorage();
      this.historyData.index++;
      this.historyData.steps[this.historyData.index] = {
        widgetList: deepClone(this.widgetList),
        formConfig: deepClone(this.formConfig)
      };
    },
    emitHistoryChange: function emitHistoryChange() {
      if (this.historyData.index === this.historyData.maxStep - 1) {
        this.historyData.steps.shift();
      } else {
        this.historyData.index++;
      }
      this.historyData.steps[this.historyData.index] = {
        widgetList: deepClone(this.widgetList),
        formConfig: deepClone(this.formConfig),
        selectNames: deepClone(this.selectNames)
      };
      this.saveFormContentToStorage();
      if (this.historyData.index < this.historyData.steps.length - 1) {
        this.historyData.steps = this.historyData.steps.slice(0, this.historyData.index + 1);
      }
    },
    saveCurrentHistoryStep: function saveCurrentHistoryStep() {
      this.historyData.steps[this.historyData.index] = deepClone({
        widgetList: this.widgetList,
        formConfig: this.formConfig,
        selectNames: this.selectNames
      });
      this.saveFormContentToStorage();
    },
    undoHistoryStep: function undoHistoryStep() {
      if (this.historyData.index !== 0) {
        this.historyData.index--;
      }
      this.widgetList = deepClone(this.historyData.steps[this.historyData.index].widgetList);
      this.formConfig = deepClone(this.historyData.steps[this.historyData.index].formConfig);
      this.selectNames = deepClone(this.historyData.steps[this.historyData.index].selectNames);
    },
    deleteHistoryStepNames: function deleteHistoryStepNames(name) {
      var index = this.selectNames.findIndex(function (item) {
        return item === name;
      });
      this.selectNames.splice(index, 1);
    },
    redoHistoryStep: function redoHistoryStep() {
      if (this.historyData.index !== this.historyData.steps.length - 1) {
        this.historyData.index++;
      }
      this.widgetList = deepClone(this.historyData.steps[this.historyData.index].widgetList);
      this.formConfig = deepClone(this.historyData.steps[this.historyData.index].formConfig);
      this.selectNames = deepClone(this.historyData.steps[this.historyData.index].selectNames);
    },
    undoEnabled: function undoEnabled() {
      return this.historyData.index > 0 && this.historyData.steps.length > 0;
    },
    redoEnabled: function redoEnabled() {
      return this.historyData.index < this.historyData.steps.length - 1;
    }
  }, "initHistoryData", function initHistoryData() {
    this.historyData = {
      index: -1,
      maxStep: 10,
      steps: []
    };
  }), "saveFormContentToStorage", function saveFormContentToStorage() {
    window.localStorage.setItem('widget__list__backup', JSON.stringify(this.widgetList));
    window.localStorage.setItem('form__config__backup', JSON.stringify(this.formConfig));
  }), "loadFormContentFromStorage", function loadFormContentFromStorage() {
    var widgetListBackup = window.localStorage.getItem('widget__list__backup');
    if (!!widgetListBackup) {
      this.widgetList = JSON.parse(widgetListBackup);
    }
    var formConfigBackup = window.localStorage.getItem('form__config__backup');
    if (!!formConfigBackup) {
      //this.formConfig = JSON.parse(formConfigBackup)
      overwriteObj(this.formConfig, JSON.parse(formConfigBackup)); /* 用=赋值，会导致inject依赖注入的formConfig属性变成非响应式 */
    }
  });
}